module.exports = __webpack_public_path__ + "img/offer-monthly.ef42849a.png";